'use strict';

module.exports = {
    ACTION_WITH_SYMBOL: 'ActionWithSymbol',
    BACK_BUTTON: 'BackButton',
    BUBBLE: 'Bubble',
    BUTTON: 'Button',
    CLOSE_BUTTON: 'CloseButton',
    CHECKBOX: 'Checkbox',
    COLOR_SPACE: 'ColorSpace',
    CONTEXT_MENU: 'ContextMenu',
    CONTEXT_MENU_ACTION: 'ContextMenuAction',
    CONTEXTUAL_DIVIDER: 'ContextualDivider',
    DATE_PICKER: 'DatePicker',
    DATE_PICKER_INPUT: 'DatePickerInput',
    DROP_DOWN: 'DropDown',
    DROP_DOWN_BASE: 'DropDownBase',
    DROP_DOWN_BASE_OPTIONS: 'DropDownBaseOptions',
    DROP_DOWN_OPTION: 'DropDownOption',
    DROP_DOWN_STICKY_FOOTER: 'DropDownStickyFooter',
    DYNAMIC_FIELD: 'DynamicField',
    EDITABLE_URL: 'EditableURL',
    FONT_FAMILY_PICKER: 'FontFamilyPicker',
    GOOGLE_PREVIEW: 'GooglePreview',
    HELP_BUTTON: 'HelpButton',
    HORIZONTAL_TABS: 'HorizontalTabs',
    ILLUSTRATION: 'Illustration',
    RADIO_BUTTONS_WITH_ILLUSTRATION: 'RadioButtonsWithIllustration',
    IMAGE_AND_TEXT_TEMPLATE: 'ImageAndTextTemplate',
    INFO_ICON: 'InfoIcon',
    MY_COLORS: 'MyColors',
    NUMERIC_INPUT: 'NumericInput',
    PALETTE: 'Palette',
    PALETTE_PICKER: 'PalettePicker',
    PANEL_HEADER: 'PanelHeader',
    PROMOTIONAL_LIST: 'PromotionalList',
    RADIO_BUTTON: 'RadioButton',
    RADIO_BUTTONS: 'RadioButtons',
    RESET_COLOR: 'ResetColor',
    RICH_TEXT: 'RichText',
    SECTION_DIVIDER: 'SectionDivider',
    TEXT_INPUT: 'TextInput',
    TEXT_INPUT_MULTI_LINE: 'TextInputMultiline',
    TEXT_LABEL: 'TextLabel',
    TOGGLE: 'Toggle',
    TOGGLE_SWITCH: 'ToggleSwitch',
    TOOLTIP: 'Tooltip',
    SLIDER: 'Slider',
    SORT_BY_DRAG_LIST_ITEM_ROW_BASE: 'SortByDragListItemRowBase',
    SORT_BY_DRAG_LIST_ITEM_ROW: 'SortByDragListItemRow',
    SORT_BY_DRAG_LIST_CUSTOM_ITEM_ROW: 'SortByDragListCustomItemRow',
    SORT_BY_DRAG_LIST_TEXT_EDIT: 'SortByDragListTextEdit'
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/displayNames.js